import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="json-renderer"
export default class extends Controller {
  static values = { json: Object };

  connect() {
    const viewer = document.getElementById("json-viewer");
    // Render it inside the Stimulus element
    viewer.innerHTML = JSON.stringify(this.jsonValue, null, 2);
  }
}
